import {dataHooks} from '@wix/data-hooks'

export const cancellationPolicyDialogDataHooks = dataHooks<{
  content: {}
}>('cancellation-policy-dialog')
